import { FunctionComponent, useEffect } from "react";
import TextInputField from "../../Components/TextInput/TextInputField";
import { FormikProps, useFormik } from "formik";
import Select from "../../Components/Select/Select";
import { IMasterList } from "./IMaster";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import * as Yup from "yup";
import {
  addMaster,
  clearAddMasterState,
} from "../../Redux/Slicers/Master/AddMasterSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearUpdateMasterState,
  updateMaster,
} from '../../Redux/Slicers/Master/UpdateMasterSlicer';

interface MasterFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const MasterForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const { updateableDate } = useAppSelector((state) => state.UpdateMaster);

  const masterFrom = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      first_name: Yup.string().required('Please enter Name'),
      email: Yup.string().email().required('Please enter Email'),
      role_id: Yup.number().required('Please select role'),
      phone: Yup.string().required('Please enter Contact Number'),
      status: Yup.string().required('Please select Status'),
    }),
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(updateMaster({ ...value, id: updateableDate._id }));
      } else {
        dispatch(addMaster(value));
      }
      // console.log(updateableDate);
      // console.log(value);
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);
    if (updateableDate) {
      masterFrom.setFieldValue('first_name', updateableDate.first_name);
      masterFrom.setFieldValue('email', updateableDate.email);
      masterFrom.setFieldValue('phone', updateableDate.phone);
      masterFrom.setFieldValue('status', updateableDate.status);
    }
    return () => {
      dispatch(clearAddMasterState());
      dispatch(clearUpdateMasterState());
      masterFrom.resetForm();
    };
  }, [updateableDate]);

  return (
    <form
      className="master_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <TextInputField
        id="first_name"
        name="first_name"
        label="Name"
        value={masterFrom.values.first_name}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.first_name && masterFrom.errors.first_name}
        error={masterFrom.touched.first_name && Boolean(masterFrom.errors.first_name)}
      />

      <TextInputField
        id="email"
        name="email"
        label="Email"
        value={masterFrom.values.email}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.email && masterFrom.errors.email}
        error={masterFrom.touched.email && Boolean(masterFrom.errors.email)}
      />

      <TextInputField
        id="phone"
        name="phone"
        label="Contact Number"
        value={masterFrom.values.phone}
        onChange={(event) => {
          masterFrom.setFieldValue(
            'phone',
            event.target.value.replace(/[^0-9.]/g, '')
          );
        }}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.phone && masterFrom.errors.phone}
        error={masterFrom.touched.phone && Boolean(masterFrom.errors.phone)}
      />

      <Select
        id="status"
        name="status"
        label="Status"
        value={
          masterFrom.values.status === null ||
          masterFrom.values.status === undefined
            ? null
            : masterFrom.values.status
            ? 'Active'
            : 'In-active'
        }
        options={['Active', 'In-active']}
        onChange={(_, value) => {
          masterFrom.setFieldValue(
            'status',
            value === null ? null : value === 'Active'
          );
        }}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.status && masterFrom.errors.status}
        error={masterFrom.touched.status && Boolean(masterFrom.errors.status)}
        placeholder="-select-"
      />

      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default MasterForm;

const initialValues = {
  first_name: '',
  email: '',
  role_id: 1,
  phone: '',
  status: null,
} as IMasterList;
